import { physicalAddressKeys, useNodeService } from "@fero/hooks";
import type { PhysicalAddressType } from "adl-gen/ferovinum/app/db";

export const useGetPhysicalAddressQuery = (
  entityId: string,
  addressType: PhysicalAddressType,
) => {
  const service = useNodeService();

  const query = service.physicalAddress.lookup.useQuery(
    physicalAddressKeys.getAddress(entityId, addressType),
    {
      query: {
        entityIds: [entityId].join(","),
        addressType,
      },
    },
  );

  return {
    ...query,
    data: query.data?.body?.items[0],
  };
};
